import styled, { css } from 'styled-components'
import { colors, media } from 'client/styles'
import { BOOKING_CONFIRMED, BOOKING_PENDING, BOOKING_ERROR } from 'src/constants/voucher'

export const MessageHeaderBase = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1100px;

  ${media.desktop} {
    margin-inline: auto;
    margin-block: auto;
  }
`

export const VoucherInformationRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline-start: 20px;
  margin-block-end: 20px;

  &:empty {
    margin-block-end: 0;
  }

  ${media.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-block-end: 0;
  }
  ${media.desktop} {
    padding-inline-start: 40px;
  }
`

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 20px;
  padding-inline: 0;
`

export const BookingStatus = styled.div`
  display: flex;

  padding-block: 20px;
  padding-inline: 0;

  ${media.tablet} {
    justify-content: center;
    align-items: center;
  }
`

export const BookingIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  fill: ${colors.white};
  margin-inline-end: 12px;
`

export const BookingIconPending = styled(BookingIcon)`
  fill: ${colors.orange};
`

const bookingConfirmed = css`
  color: ${colors.green};
`

const bookingPending = css`
  color: ${colors.orange};
`

export const BookingStatusText = styled.h1`
  font-weight: 700;
  font-size: 24px;

  ${props => props.bookingStatus === BOOKING_CONFIRMED && bookingConfirmed};
  ${props =>
    (props.bookingStatus === BOOKING_PENDING || props.bookingStatus === BOOKING_ERROR) &&
    bookingPending};

  ${media.mobile} {
    font-size: 28px;
  }
`

export const BookingUnconfirmedText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;

  padding-inline-start: 10px;

  color: ${colors.grey2};

  ${media.mobile} {
    padding-inline-start: 40px;
  }
`
